/// <reference types="grecaptcha" />
import '@ts/pages/page-defaults';
import { ___, getLocale } from '@ts/common/language';
import { fetchData, isHttpErrorWithStatus, isHttpErrorWithValidationData } from '@ts/common/request';
const form = document.getElementById('coach-onboarding-form');
if (form) {
    const sitekey = form.getAttribute('data-recaptcha-sitekey') ?? '';
    const successEl = document.getElementById('inquiry-success');
    const formWrapper = document.getElementById('inquiry-form-wrapper');
    const alertEl = document.getElementById('form-alert');
    const submitBtn = form.querySelector('#submit-btn');
    function showFieldError(field, message) {
        const el = document.getElementById('error-' + field);
        if (el) {
            el.textContent = message;
            el.classList.remove('hidden');
        }
        const input = form.querySelector(`[name="${field}"], [name="data[${field}]"]`);
        if (input)
            input.classList.add('invalid');
    }
    function clearErrors() {
        form.querySelectorAll('.invalid-message').forEach(el => {
            el.textContent = '';
            el.classList.add('hidden');
        });
        form.querySelectorAll('.invalid').forEach(el => el.classList.remove('invalid'));
        if (alertEl) {
            alertEl.textContent = '';
            alertEl.classList.add('hidden');
        }
    }
    function showAlert(message) {
        if (alertEl) {
            alertEl.textContent = message;
            alertEl.classList.remove('hidden');
        }
    }
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        clearErrors();
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.classList.add('processing');
        }
        grecaptcha.ready(() => {
            grecaptcha.execute(sitekey, { action: 'coach_onboarding' }).then(async (token) => {
                const body = {
                    captcharesponse: token,
                    data: {
                        athletes: (form.querySelector('#athletes'))?.value,
                        role: (form.querySelector('#role'))?.value,
                        ...(form.dataset.campaign ? { campaign: form.dataset.campaign } : {}),
                    },
                };
                // Guest fields
                const nameInput = form.querySelector('#name');
                const emailInput = form.querySelector('#email');
                const agreeInput = form.querySelector('#agreeTerms');
                if (nameInput)
                    body.name = nameInput.value;
                if (emailInput)
                    body.email = emailInput.value;
                if (agreeInput)
                    body.agree_terms = agreeInput.checked ? '1' : '0';
                try {
                    await fetchData('/api/v1/inquiry/coach_request?locale=' + getLocale(), {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': window.csrf,
                        },
                        body: JSON.stringify(body),
                    });
                    // Success
                    if (formWrapper)
                        formWrapper.classList.add('hidden');
                    if (successEl) {
                        successEl.classList.remove('hidden');
                        // successEl.scrollIntoView({behavior: 'smooth'});
                    }
                }
                catch (error) {
                    if (submitBtn) {
                        submitBtn.disabled = false;
                        submitBtn.classList.remove('processing');
                    }
                    if (isHttpErrorWithValidationData(error)) {
                        for (const [key, messages] of Object.entries(error.data.errors)) {
                            const field = key.replace('data.', '');
                            showFieldError(field, messages[0]);
                        }
                        showAlert(___({ en: 'Please check your inputs.', de: 'Bitte überprüfe deine Eingaben.' }));
                    }
                    else if (isHttpErrorWithStatus(error, 429)) {
                        showAlert(___({ en: 'You have already submitted a request recently. Please try again later.', de: 'Du hast bereits kürzlich eine Anfrage gesendet. Bitte versuche es später erneut.' }));
                    }
                    else {
                        showAlert(___({ en: 'An error occurred. Please try again.', de: 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.' }));
                    }
                    //   form.scrollIntoView({behavior: 'smooth'});
                }
            });
        });
    });
}
